import { Component, TemplateRef } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';

import { CompanyStateService } from 'src/app/auth/services/company-state.service';

import { UserStateService } from 'src/app/auth/services/user-state.service';
import { RvshareAppDetectionService } from 'src/app/screen-sharing/services/rvshare-app-detection.service';

@Component({
  selector: 'auth-buttons',
  templateUrl: './auth-buttons.component.html',
  styleUrl: './auth-buttons.component.scss',
  standalone: false,
})
export class AuthButtonsComponent {
  get isScreenShareApp(): any {
    return this.rvShareAppDetection.isScreenShareApp();
  }

  get userPicture() {
    return this.userStateService.getUserPicture();
  }

  get companyName() {
    return this.companyStateService.getUserCompanyName();
  }

  get username() {
    return this.userStateService.getUsername();
  }

  get userFullName() {
    return this.userStateService.getUserFullName();
  }

  constructor(
    private rvShareAppDetection: RvshareAppDetectionService,
    private userStateService: UserStateService,
    private companyStateService: CompanyStateService,
    public actionSheet: MatBottomSheet,
  ) {}

  openMobileMenu(template: TemplateRef<any>) {
    this.actionSheet.open(template, {
      panelClass: 'auth-buttons-action-sheet',
      ariaLabel: 'User Menu',
      ariaModal: true,
    });
  }

  onMenuOpened() {
    setTimeout(() => {
      const firstFocusableElement = document.querySelector(
        '.auth-buttons-menu [tabindex="0"]',
      ) as HTMLElement;
      if (firstFocusableElement) {
        firstFocusableElement.focus();
      }
    }, 50);
  }

  /**
   * Handles keyboard navigation within the menu for accessibility compliance.
   * Implements circular navigation using arrow keys.
   *
   * @param event - The keyboard event triggered by user interaction
   *
   * Navigation keys:
   * - ArrowDown/ArrowUp: Move focus to next/previous element in a circular manner
   * - When reaching the end, focus wraps to the beginning (and vice versa)
   */
  onMenuKeydown(event: KeyboardEvent) {
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      event.preventDefault();
      event.stopPropagation();

      const focusableElements = (
        event.currentTarget as HTMLElement
      ).querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]):not([disabled])',
      );
      const focusableArray = Array.from(focusableElements) as HTMLElement[];
      const currentIndex = focusableArray.indexOf(
        document.activeElement as HTMLElement,
      );

      let nextIndex: number;
      if (event.key === 'ArrowUp') {
        nextIndex =
          currentIndex > 0 ? currentIndex - 1 : focusableArray.length - 1;
      } else {
        nextIndex =
          currentIndex < focusableArray.length - 1 ? currentIndex + 1 : 0;
      }

      focusableArray[nextIndex]?.focus();
    }
  }
}
